export default function Button({
  children,
  onClick = () => {},
  disabled = false,
  className = '',
  component = 'filled',
}) {
  const elementos = [
    {
      name: 'filled',
      classes:
        'bg-primary-main border-primary-main disabled:border-divider-dark disabled:bg-divider-dark text-neutras-white',
    },
    { name: 'error', classes: 'bg-error-main disabled:bg-divider-dark text-neutras-white' },
    {
      name: 'outlined',
      classes:
        'bg-transparent text-primary-main border-2 border-primary-main disabled:text-grey-medium disabled:bg-sucess-disabled disabled:border-grey-medium',
    },
  ];
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`px-3 py-2 rounded-xl flex-row text-center justify-center items-center gap-2 inline-flex border-solid cursor-pointer
        ${elementos.find(e => e.name == component)?.classes} ${className}`}
    >
      {children}
    </button>
  );
}
